import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BaseAddOnProductParserComponent } from './base-add-on-product-parser.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		BaseAddOnProductParserComponent
	],
	exports: [
		BaseAddOnProductParserComponent
	]
})
export class BaseAddOnProductParserModule {}
